import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  button: css`
    margin-left: auto;
  `,
  loader: css`
    --foreground-color: white;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
